import {
  ACCENT_COLOR_TYPE_BY_BONUS,
  acceptModeType,
  BONUSES_TYPES_FOR_IMAGES,
  riskFreeStates
} from '../../../constants';
import prepareBonusDetailsList from '../../../utils/prepareBonusDetailsList';

export const normalizeRiskFreeBonusDetails = ({ bonusData, f, t }) => {
  const { state, acceptMode, expireTime = {}, betDateReceipt = {} } = bonusData;

  const DATE_FORMATS_TYPES = f.getFormats();

  const isActivation = state === riskFreeStates.ERF_STATE_ACTIVATION_REQUEST;
  const isActive = state === riskFreeStates.ERF_STATE_ACTIVE;

  return {
    ...bonusData,
    expireTime: {
      ...expireTime,
      ms: expireTime.sec * 1000 || 0
    },
    isActivation,
    isActive,
    isShowButton:
      isActivation || isActive || acceptModeType.ACCEPT.includes(acceptMode),
    isCountdownTimerEnabled:
      state === riskFreeStates.ERF_STATE_AVAILABLE ||
      state === riskFreeStates.ERF_STATE_ACTIVE,
    countdownTimerTitle: (() => {
      if (state === riskFreeStates.ERF_STATE_AVAILABLE) {
        return t('web.personaloffice.bonuses.timer.time.to.accepts');
      }
      if (state === riskFreeStates.ERF_STATE_ACTIVE) {
        return t('web.personaloffice.bonuses.timer.time.to.use');
      }

      return '';
    })(),
    buttonType: (() => {
      if (isActive) {
        return 'placeBet';
      }

      return 'accept';
    })(),
    bonusDetailsList: (() =>
      prepareBonusDetailsList([
        {
          name: t('web.personaloffice.bonuses.complited'),
          value: f
            .getDateTime({
              date: Date.parse(betDateReceipt)
            })
            ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
          isDisplay:
            state === riskFreeStates.ERF_STATE_COMPLETED ||
            state === riskFreeStates.ERF_STATE_COMPLETED_2
        },
        {
          name: t('web.personaloffice.bonuses.expired.date'),
          value: f
            .getDateTime({ date: expireTime?.sec * 1000 || expireTime?.sec })
            ?.toFormat(DATE_FORMATS_TYPES.BONUSES_DATE_FORMAT),
          isDisplay:
            state === riskFreeStates.ERF_STATE_EXPIRED_TIME_ACTIVATION ||
            state === riskFreeStates.ERF_STATE_EXPIRED_TIME_USAGE
        }
      ]))(),
    imageColorAccent:
      ACCENT_COLOR_TYPE_BY_BONUS[BONUSES_TYPES_FOR_IMAGES.CRM_RISK_FREE_BONUS]
  };
};
